import { Stack, Select, MenuItem, Pagination, paginationItemClasses, styled, selectClasses } from '@mui/material';
import React from 'react';
import { generateNamesObject } from '../../utils';

const paginationControlsClasses = generateNamesObject(['root'], 'PaginationControls');

const Controls = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(1),
    justifyContent: 'space-between',
    alignItems: 'center',
    wrap: 'nowrap',
    gap: theme.spacing(1),
    [`& .${selectClasses.iconStandard}`]: {
        top: 'auto',
        color: 'inherit',
    },
    [`& .${paginationItemClasses.root}`]: {
        padding: 0,
        margin: 0,
    },
}));

type PaginationControlsProps = {
    currentPage: number;
    totalPages: number;
    onCurrenPageChange: (page: number) => void;
    itemsPerPage: number;
    onItemsPerPageChange: (page: number) => void;
    itemsPerPageOptions: number[];
};

export const PaginationControls: React.FC<PaginationControlsProps> = ({
    currentPage,
    totalPages,
    onCurrenPageChange,
    itemsPerPage,
    onItemsPerPageChange,
    itemsPerPageOptions,
}) => (
    <Controls direction="row" className={paginationControlsClasses.root}>
        <Pagination
            color="primary"
            count={totalPages}
            page={currentPage}
            siblingCount={0}
            boundaryCount={1}
            onChange={(_event, page) => onCurrenPageChange(page)}
        />
        <Select
            value={itemsPerPage}
            onChange={(event) => onItemsPerPageChange(Number(event.target.value as number))}
            variant="standard"
            disableUnderline
        >
            {itemsPerPageOptions.map((value) => (
                <MenuItem key={value} value={value} disableRipple>
                    {value}
                </MenuItem>
            ))}
        </Select>
    </Controls>
);
